import { render, staticRenderFns } from "./CampaignPrelander.vue?vue&type=template&id=1b921dde&scoped=true"
import script from "./CampaignPrelander.vue?vue&type=script&lang=js"
export * from "./CampaignPrelander.vue?vue&type=script&lang=js"
import style0 from "./CampaignPrelander.vue?vue&type=style&index=0&id=1b921dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b921dde",
  null
  
)

export default component.exports